
import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image, Font } from '@react-pdf/renderer';
import { Table, TableHeader, TableCell, TableBody, DataTableCell } from "@david.kucsai/react-pdf-table";
import premier_letter_head from "../img/premier_letterhead.jpeg";
import RobotoBold from "../assets/fonts/Roboto-Bold.ttf";
import RobotoRegular from "../assets/fonts/Roboto-Regular.ttf";
import RobotoLight from "../assets/fonts/Roboto-Light.ttf";


// Register font
// Font.register(
// {
//   family: 'RobotoLight',
//   fonts: [
//     {
//       src: RobotoLight
//     }
//   ]
// }
// );

Font.register({
  family: "Roboto",
  fonts: [
    {
      src: RobotoLight,
      fontWeight: 300,
    },
    {
      src: RobotoRegular,
      fontWeight: 400,
    },
    {
      src: RobotoBold,
      fontWeight: 700,
    }

  ]
});

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: 10,
  },
  section: {
    margin: 10,
    padding: 10,
  },
  topSectionSingleRow:
  {
    flexDirection: "row",
    marginTop: 10
  },
  top_section_label: {
    fontSize: 14,
    fontFamily: "Roboto",
    fontWeight: 400,
    width: "25%"
  },
  top_section_value: {
    fontSize: 13,
    fontFamily: "Roboto",
    fontWeight: 300,
    width: "75%"
  },

  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },


});

const DocumentAfterQuotationGeneration = (props) => (





  <Document>

    <>
      {
        console.log("datafrom main parent", props.dataFromParentPage?.table_row_values)
      }
    </>

    <Page size="A4" style={styles.page}>

      <View>

        <View>
          <Image source={premier_letter_head} />
        </View>

        <View style={{ marginTop: 20, marginBottom: 20 }}>
          <View style={styles.topSectionSingleRow}>
            <Text style={styles.top_section_label}>Quotation No.</Text><Text style={styles.top_section_value}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. In sit amet mi quis neque maximus ultricies. Fusce efficitur lacus ac tortor dapibus lacinia. Curabitur non consectetur ipsum, posuere lobortis ipsum. Aenean a sodales erat. Integer at purus elit. Duis ut mauris at felis placerat tempus eu eget augue. </Text>
          </View>
          <View style={styles.topSectionSingleRow}>
            <Text style={styles.top_section_label}>Date & Time</Text><Text style={styles.top_section_value}>Date & Time</Text>
          </View>
          <View style={styles.topSectionSingleRow}>
            <Text style={styles.top_section_label}>Reference</Text><Text style={styles.top_section_value}>Reference</Text>
          </View>
          <View style={styles.topSectionSingleRow}>
            <Text style={styles.top_section_label}>Remarks</Text><Text style={styles.top_section_value}>Remarks</Text>
          </View>

        </View>

        <Table
          data={

            props.dataFromParentPage?.table_row_values
          }
        >
          <TableHeader>
            <TableCell>
              Part Number
            </TableCell>
            <TableCell>
              Description
            </TableCell>
            <TableCell>
              Qty
            </TableCell>
            <TableCell>
              Unit Price
            </TableCell>
            <TableCell>
              Total
            </TableCell>
          </TableHeader>
          <TableBody>
            <DataTableCell getContent={(r) => r.so_icode} />
            <DataTableCell getContent={(r) => r.idesc} />
            <DataTableCell getContent={(r) => r.tr_qty2} />
            <DataTableCell getContent={(r) => r.so_fccost} />
            <DataTableCell getContent={(r) => r.tr_qty2 * r.so_fccost} />
          </TableBody>
        </Table>

      </View>

      <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
        `${pageNumber} / ${totalPages}`
      )} fixed />

    </Page>
  </Document>
);

export default DocumentAfterQuotationGeneration;